export enum FlowMode {
  Workflow = 'workflow',
  App = 'app',
}
